import { useRef } from "react";
import { ActionHandlerProvider } from "../Components/ActionHandlerContext";
import DynamicMaster from "../Components/DynamicMaster/DynamicMaster";
import { FormInstance } from "antd";

export default function ADUserMaster() {
  const formRef = useRef<FormInstance>(null);
  const reportActionHandler = {
    checkIfValidationOK: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      // return `Successfully edited record with ID ${params[0]}`; // Return message
      return true;
    },
    Query: async (...params: any[]) => {
      console.log(`${params[1]} 387 action with parameters:`, params);
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    CheckReportActionFunction: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      console.log("CheckReportActionFunction run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      // return `Successfully edited record with ID ${params[0]}`; // Return message
      return true;
    },
  };
  const rowActionHandler = {
    DynamicMasterRowView: async (...params: any[]) => {
      console.log(`${params[1]} action with parameters:`, params);
      console.log("rowActionHandler");
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
  };

  const interfaceActionHandler = {
    handleSubmit: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      console.log("handleSubmit run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      // return `Successfully edited record with ID ${params[0]}`; // Return message
      return true;
    },
    handleEndFunction: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      console.log("handleEndFunction run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      // return `Successfully edited record with ID ${params[0]}`; // Return message
      return true;
    },
    Query: async (...params: any[]) => {
      console.log(`${params[1]} 409 action with parameters:`, params);
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
  };

  const interfaceFieldActionHandler = {
  SetStateSingleValue: async (form: any) => {
      let formData = form.getFieldsValue();
      console.log(formData);
    },
    HandleRoleOnChange: async (form: any) => {
      
      let values: Record<string, any>;
      if ('getFieldsValue' in form) {
        values = form.getFieldsValue();
      } else {
        values = form;
      }

      console.log(values);
      if(values['ADUserRole'] === '1')
      {
        await formRef.current!.hideField('Site');
      }
      else
      {
        await formRef.current!.showField('Site');
      }
    }
  
  };

  const autoSearchActionHandler = {
    fetchAutoDropdownData : async (fieldId: string, execParams: any) => {
      try {
      //  const response = await fetch("/api/Common/GetAzureADUserByClientSecret", {  //  Get Details Using ClientSecret
          const response = await fetch("/api/Common/GetAzureADUser", {  //  Get Details Using ClientCertificate
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            FieldId: fieldId,
            FormData: JSON.stringify(execParams)
          }),
        });
        
        let result = await response.json()
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        else
        {
            result.data = result?.data?.map((item: any) => ({
                    label: item?.Name,
                    value: [
                      item.Name ?? "",
                      item.EmailId ?? "",
                      item.LoginId ?? "",
                      item.firstName ?? "",
                      item.lastName ?? "",
                    ]
                      .filter(Boolean)
                      .join(" | "),
                  }))
        }

        return result; // Parse and return the JSON response
      } catch (error) {
        console.error(`Error fetching data for ${fieldId}:`, error);
        return []; // Return an empty array in case of an error
      }
    }
  }
  
  return (
    <ActionHandlerProvider
      rowActionHandler={rowActionHandler}
      reportActionHandler={reportActionHandler}
      interfaceActionHandler={interfaceActionHandler}
      interfaceFieldActionHandler={interfaceFieldActionHandler}
      autoSearchActionHandler={autoSearchActionHandler}
    >
      {/* <DynamicReport interfaceId={5} dashboardId={3} /> */}
      {/* <DynamicReport interfaceId={3} dashboardId={1} /> */}
      {/* <DynamicMaster InterfaceName={'State Master'} DashboardName={'State Dashboard'} ref={formRef}/> */}
      <DynamicMaster InterfaceName={'AD User Master'} DashboardName={'AD User Master'} ref={formRef}/>
    </ActionHandlerProvider>
  );
}
